export default __webpack_public_path__ + "static/media/logo_ec.df74c432.svg";